import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'shippingdestinytransportation',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `shippingdestinytransportation`,
    method: 'get',
    params: queriesParams
  })
}

export function addShippingDestinyTransportation (shippingDestinyTransportation) {
  return request({
    method: 'post',
    url: 'shippingdestinytransportation',
    data: shippingDestinyTransportation
  })
}

export function show (id) {
  return request({
    url: `shippingdestinytransportation/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `shippingdestinytransportation/${id}`,
    method: 'patch',
    data
  })
}
